import React from 'react'
import { Button, Icon } from '../../components'
import {
  formatCouponBenefitShort,
  formatCouponBenefitTitle,
  getCouponBenefitDescription,
  getCouponFrequencyBadge,
  getCouponFrequencyLabel,
  getCreditsReceiveSummary,
  getPlanReceiveSummary,
  getRedeemReceiveSummary,
} from '../../utils/couponBenefits'

export const CouponBenefitPreview = ({ coupon, context = 'credits', onRemove }) => {
  if (!coupon) {
    return null
  }

  const bannerIcon = context === 'plan' || (context === 'redeem' && coupon.bonus_documents && !coupon.bonus_credits)
    ? 'icon-file'
    : 'icon-coin'

  return (
    <div className="coupon-benefit-banner">
      <Icon id={bannerIcon} size="20" className="coupon-benefit-banner-icon" />
      <div className="coupon-benefit-banner-content">
        <div className="coupon-benefit-banner-header">
          <p className="coupon-benefit-banner-title">{formatCouponBenefitTitle(coupon)}</p>
          {onRemove && (
            <Button
              variant="link"
              className="coupon-benefit-banner-remove"
              onClick={onRemove}
              aria-label="Remover cupom"
            >
              Remover
            </Button>
          )}
        </div>
        <p className="coupon-benefit-banner-description">
          {getCouponBenefitDescription(context, coupon)}
        </p>
        <p className="coupon-benefit-banner-frequency">
          <Icon id="icon-cached" size="16" />
          {getCouponFrequencyLabel(coupon, context)}
        </p>
      </div>
    </div>
  )
}

export const CouponAppliedSection = ({
  coupon,
  code,
  context = 'credits',
  purchasedCredits,
  planMaxDocuments,
  planName,
  onRemove,
  onChange,
}) => {
  if (!coupon || !code) {
    return (
      <div className="coupon-applied-section coupon-applied-section--empty">
        <p>Cupom</p>
        <Button variant="link" className="cupom-button" onClick={onChange}>
          Adicionar cupom
        </Button>
      </div>
    )
  }

  const receiveSummary = context === 'plan'
    ? getPlanReceiveSummary(planMaxDocuments, coupon)
    : getCreditsReceiveSummary(purchasedCredits, coupon)

  return (
    <>
      <CouponBenefitPreview coupon={coupon} context={context} onRemove={onRemove} />

      <div className="payment-summaryRow">
        <p className="payment-summaryRow-title">
          {context === 'plan' ? 'Resumo da contratação' : 'Resumo da compra'}
        </p>
      </div>

      {context === 'credits' ? (
        <div className="coupon-summary-row">
          <span>Créditos comprados</span>
          <span className="fw-500">{purchasedCredits} créditos</span>
        </div>
      ) : (
        <div className="coupon-summary-row">
          <span>Plano {planName}</span>
          <span className="fw-500">{planMaxDocuments} documentos/mês</span>
        </div>
      )}

      <div className="coupon-summary-row coupon-summary-row--bonus">
        <span className="coupon-summary-label">
          <Icon id="icon-coin" size="16" />
          Bônus do cupom {code}
        </span>
        <span className="coupon-summary-bonus-value">
          {formatCouponBenefitShort(coupon)}
          <span className="coupon-summary-badge">{getCouponFrequencyBadge(coupon, context)}</span>
        </span>
      </div>

      <div className="coupon-receive-summary">
        <span>Você recebe</span>
        <span className="coupon-receive-summary-value">{receiveSummary}</span>
      </div>
    </>
  )
}

export const CouponRedeemSection = ({
  coupon,
  code,
  onRemove,
  onChange,
}) => {
  if (!coupon || !code) {
    return (
      <div className="coupon-redeem-row">
        <span>Cupom</span>
        <Button variant="link" className="cupom-button" onClick={onChange}>
          Adicionar cupom
        </Button>
      </div>
    )
  }

  const receiveSummary = getRedeemReceiveSummary(coupon)

  return (
    <>
      <CouponBenefitPreview coupon={coupon} context="redeem" onRemove={onRemove} />

      <div className="payment-summaryRow">
        <p className="payment-summaryRow-title">Resumo do resgate</p>
      </div>

      <div className="coupon-summary-row coupon-summary-row--bonus">
        <span className="coupon-summary-label">
          <Icon id="icon-coin" size="16" />
          Bônus do cupom {code}
        </span>
        <span className="coupon-summary-bonus-value">
          {formatCouponBenefitShort(coupon)}
          <span className="coupon-summary-badge">{getCouponFrequencyBadge(coupon)}</span>
        </span>
      </div>

      <div className="coupon-receive-summary">
        <span>Você recebe</span>
        <span className="coupon-receive-summary-value">{receiveSummary}</span>
      </div>

      <div className="coupon-redeem-cost">
        <span>Custo</span>
        <span className="coupon-redeem-cost-value">Grátis</span>
      </div>
    </>
  )
}
